export default [
	'Behavioral',
	'Biological/Vaccine',
	'Burden',
	'Device',
	'Dietary Supplement',
	'Drug',
	'Genetic',
	'Lifestyle Modification',
	'Non-Screening',
	'Other',
	'Procedural/Surgery',
	'Radiotherapy',
	'Safety',
	'Screening',
]
